import { useEffect, useState } from 'react';
import { BoxProps, Flex, ProgressProps } from '@chakra-ui/react';

import { validatePassword } from 'utils/validation';
import { Progress } from 'components/UI/Progress';
import { Text } from 'components/UI/Text';

type PasswordStrengthProps = {
  value?: string;
  progressProps?: ProgressProps;
  wrapperProps?: BoxProps;
};

const PasswordStrength = ({ value, progressProps = {}, wrapperProps = {} }: PasswordStrengthProps) => {
  const [score, setScore] = useState<number>(0);

  useEffect(() => {
    setScore(validatePassword(value ?? ''));
  }, [value]);

  return (
    <Flex alignItems="center" gap={4} {...wrapperProps}>
      <Progress value={score} min={0} max={4} width="full" {...progressProps} />
      <Text as="small">{!value || value.length < 8 ? value?.length ?? 0 : 8}&nbsp;/&nbsp;8</Text>
    </Flex>
  );
};

export { PasswordStrength };
